import { JSX } from "react";
import { Link } from "react-router-dom";
import { MemberSetModel } from "./memberSetModels";

export default function MemberSetIconBox(memberSet: MemberSetModel, location: string ): JSX.Element {
  return (
    <div data-bs-animation-effect="fadeInUpSmall" data-bs-effect-delay="0">
      <div className="body">
        <div className="row w-100">
          <div className="color-caribbean-green">
            <span className="icon-container px-2">
              <i className={memberSet.sourceMemberSetId ? "fa fa-filter" : "fa fa-users"} />
            </span>
            <Link to={location} className="apply-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" title={memberSet.resource.name}>
              {memberSet.resource.name}
            </Link>
          </div>
        </div>
      </div>
    </div>);
}
